import { Currency } from "../../../index";

type CreditConstructorProps = {
	currency: Currency;
	available: number;
	reserved: number;
	used: number;
};

class Credit {
	currency: Currency;
	available: number;
	reserved: number;
	used: number;

	constructor({
		currency,
		available,
		reserved,
		used,
	}: CreditConstructorProps) {
		this.currency = currency;
		this.available = available;
		this.reserved = reserved;
		this.used = used;
	}

	static fromPaddleAmount = (amount?: any) =>
		parseFloat((amount || 0).toString()) / 100;

	static toPaddleAmount = (amount?: number) => (amount || 0) * 100;

	static fromPaddleCredit(json: any) {
		return new Credit({
			currency: json.currency_code || Currency.defaultValue,
			available: Credit.fromPaddleAmount(json.balance.available),
			reserved: Credit.fromPaddleAmount(json.balance.reserved),
			used: Credit.fromPaddleAmount(json.balance.used),
		});
	}

	static fromJson(json: any) {
		return new Credit({
			currency: json.currency_code || Currency.defaultValue,
			available: Credit.fromPaddleAmount(json.available),
			reserved: Credit.fromPaddleAmount(json.reserved),
			used: Credit.fromPaddleAmount(json.used),
		});
	}

	toJson() {
		const res = {
			currency_code: this.currency,
			available: Credit.toPaddleAmount(this.available),
			reserved: Credit.toPaddleAmount(this.reserved),
			used: Credit.toPaddleAmount(this.used),
		} as any;
		return res;
	}
}

export { Credit };
